import request from '@/utils/request.js'
import main from '@/main'

const basePath = '/Function/Bus/Driver/';

const state = {};

const mutations = {};

const actions = {

  Get({commit}, view) {
    return request.PromiseCall(basePath, 'Get', view);
  }


};

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/Function/Driver/index.js